import _ from 'lodash'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'
import type {SingleComponentPluginFunction} from '../../types'

export const unpack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    const {overrides, ...otherProps} = component
    const data = _.pickBy(otherProps, _.isPlainObject)
    const structure = _.omitBy(otherProps, _.isPlainObject)

    Object.keys(component).forEach(key => {
        delete component[key]
    })

    component.data = data
    component.structure = structure
    if (overrides) {
        component.overrides = overrides
    }
}
